import { render, staticRenderFns } from "./SearchClientTable.vue?vue&type=template&id=4b1dc4c2&"
import script from "./SearchClientTable.vue?vue&type=script&lang=js&"
export * from "./SearchClientTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports